package app.model

import kotlinx.serialization.Serializable

@Serializable
data class ProjectWithDependencies(
    val id: Int, val name: String, val description: String?, val companyProjects: List<Company>
) {
    @Serializable
    data class Company(
        val id: Int, val name: String, val companyId: Int, val stages: List<Stage>
    ) {
        @Serializable
        data class Stage(
            val id: Int, val name: String, val ordering: Int, val latestRolloutExecution: RolloutExecution?
        )
    }
}
